"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.validate = validate;
const dist_1 = require("../../fs/dist");
const validation_1 = require("../../core/dist/validation");
const path = __importStar(require("path"));
async function validateWeave(weaveId, index, loomRoot, deps) {
    const issues = [];
    const weavePath = path.join(loomRoot, 'loom', weaveId);
    if (!await deps.fs.pathExists(weavePath)) {
        return { id: weaveId, issues: ['Weave directory not found'] };
    }
    const docs = [];
    const files = await (0, dist_1.findMarkdownFiles)(weavePath);
    for (const file of files) {
        try {
            const doc = await deps.loadDoc(file);
            docs.push(doc);
        }
        catch (e) {
            issues.push(`Failed to load ${path.relative(loomRoot, file)}: ${e.message}`);
        }
    }
    if (docs.length === 0) {
        return { id: weaveId, issues: ['Weave is empty'] };
    }
    for (const doc of docs) {
        if (doc.parent_id && !(0, validation_1.validateParentExists)(doc, index)) {
            issues.push(`Broken parent_id: ${doc.id} → ${doc.parent_id}`);
        }
        const dangling = (0, validation_1.getDanglingChildIds)(doc, index);
        for (const childId of dangling) {
            issues.push(`Dangling child_id: ${doc.id} → ${childId}`);
        }
        if (doc.type === 'plan') {
            const plan = doc;
            if (plan.parent_id) {
                const parentDesign = docs.find(d => d.id === plan.parent_id);
                if (parentDesign && plan.design_version != null && plan.design_version !== parentDesign.version) {
                    issues.push(`Plan ${plan.id} is stale (design v${parentDesign.version}, plan expects v${plan.design_version})`);
                }
            }
            if (!plan.steps || plan.steps.length === 0) {
                if (plan.status !== 'done') {
                    issues.push(`Plan ${plan.id} has no canonical Steps table`);
                }
            }
            else {
                const blockerIssues = (0, validation_1.validateStepBlockers)(plan, index);
                // Prefix each message with the plan ID so diagnostics.ts can map them to the right file
                issues.push(...blockerIssues.map(i => `Plan ${plan.id}: ${i.message}`));
            }
        }
    }
    return { id: weaveId, issues };
}
async function validate(input, deps) {
    const loomRoot = deps.getActiveLoomRoot(deps.loomRoot);
    const weavesDir = path.join(loomRoot, 'loom');
    const index = await deps.buildLinkIndex(loomRoot);
    const results = [];
    if (input.weaveId) {
        const result = await validateWeave(input.weaveId, index, loomRoot, deps);
        results.push(result);
    }
    else if (input.all) {
        const entries = await deps.fs.readdir(weavesDir);
        for (const entry of entries) {
            const weavePath = path.join(weavesDir, entry);
            const stat = await deps.fs.stat(weavePath);
            if (stat.isDirectory() && entry !== '.archive') {
                try {
                    results.push(await validateWeave(entry, index, loomRoot, deps));
                }
                catch {
                    results.push({ id: entry, issues: ['Failed to load weave'] });
                }
            }
        }
    }
    else {
        throw new Error('Specify a weave ID or use --all to validate all weaves.');
    }
    return { results, index };
}
